import loadable from "@loadable/component";

export const AddEditCategoryForm = loadable(() =>
  import("./EditCategoryForm/index.form"),
);
